/**
 * NavigationBlockItem
 */
import React from 'react';
import { Text, Icon } from 'ui-component-library/base';
import clsx from 'clsx';
import { Link as LinkBase } from 'ui-component-library/base';
/** Naviagation list with links. */
var NavigationBlockItem = function (_a) {
    var heading = _a.heading, text = _a.text, _b = _a.url, url = _b === void 0 ? '#' : _b, _c = _a.headingLevel, headingLevel = _c === void 0 ? 'h2' : _c, _d = _a.LinkComponent, LinkComponent = _d === void 0 ? LinkBase : _d, _e = _a.icon, icon = _e === void 0 ? 'arrow' : _e, _f = _a.borderTop, borderTop = _f === void 0 ? true : _f;
    var Link = LinkComponent;
    var Heading = headingLevel;
    return (React.createElement(Link, { to: url, className: clsx(!borderTop && 'lg:border-none', 'block py-8 no-underline border-greyLight border-t-0 lg:border-t-2 border-b-2 lg:border-b-0 group') },
        React.createElement("div", { className: "flex justify-between" },
            React.createElement(Heading, { className: "mt-0 mb-4 text-h2 text-teal group-hover:underline" }, heading),
            React.createElement(Icon, { icon: icon, size: 1.25, className: "flex-shrink-0 mx-4 mt-2 group-hover:translate-x-4 text-teal" })),
        React.createElement(Text, { as: "p", margin: false }, text)));
};
export default NavigationBlockItem;
